/*                                                                           */

import { DEV } from 'esm-env';

export *  from '../shared/errors.js';

/**
 *
 *
 */
export function async_derived_orphan() {
	if (DEV) {
		const error = new Error(`async_derived_orphan\nCannot create a \`$derived(...)\` with an \`await\` expression outside of an effect tree\nhttps:/*                                  */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                  */
	}
}

/**
 *
 *
 */
export function bind_invalid_checkbox_value() {
	if (DEV) {
		const error = new Error(`bind_invalid_checkbox_value\nUsing \`bind:value\` together with a checkbox input is not allowed. Use \`bind:checked\` instead\nhttps:/*                                         */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                         */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function bind_invalid_export(component, key, name) {
	if (DEV) {
		const error = new Error(`bind_invalid_export\nComponent ${component} has an export named \`${key}\` that a consumer component is trying to access using \`bind:${key}\`, which is disallowed. Instead, use \`bind:this\` (e.g. \`<${name} bind:this={component} />\`) and then access the property on the bound component instance (e.g. \`component.${key}\`)\nhttps:/*                                 */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function bind_not_bindable(key, component, name) {
	if (DEV) {
		const error = new Error(`bind_not_bindable\nA component is attempting to bind to a non-bindable property \`${key}\` belonging to ${component} (i.e. \`<${name} bind:${key}={...}>\`). To mark a property as bindable: \`let { ${key} = $bindable() } = $props()\`\nhttps:/*                               */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                               */
	}
}

/**
 *
 *
 *
 *
 */
export function component_api_changed(method, component) {
	if (DEV) {
		const error = new Error(`component_api_changed\nCalling \`${method}\` on a component instance (of ${component}) is no longer valid in Svelte 5\nhttps:/*                                   */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                   */
	}
}

/**
 *
 *
 *
 *
 */
export function component_api_invalid_new(component, name) {
	if (DEV) {
		const error = new Error(`component_api_invalid_new\nAttempted to instantiate ${component} with \`new ${name}\`, which is no longer valid in Svelte 5. If this component is not under your control, set the \`compatibility.componentApi\` compiler option to \`4\` to keep it working.\nhttps:/*                                       */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                       */
	}
}

/**
 *
 *
 */
export function derived_references_self() {
	if (DEV) {
		const error = new Error(`derived_references_self\nA derived value cannot reference itself recursively\nhttps:/*                                     */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                     */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function each_key_duplicate(a, b, value) {
	if (DEV) {
		const error = new Error(`each_key_duplicate\n${value
			? `Keyed each block has duplicate key \`${value}\` at indexes ${a} and ${b}`
			: `Keyed each block has duplicate key at indexes ${a} and ${b}`}\nhttps:/*                                */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                */
	}
}

/**
 *
 *
 *
 *
 *
 */
export function each_key_volatile(index, a, b) {
	if (DEV) {
		const error = new Error(`each_key_volatile\nKeyed each block has key that is not idempotent — the key for item at index ${index} was \`${a}\` but is now \`${b}\`. Keys must be the same each time for a given item\nhttps:/*                               */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                               */
	}
}

/**
 *
 *
 *
 */
export function effect_in_teardown(rune) {
	if (DEV) {
		const error = new Error(`effect_in_teardown\n\`${rune}\` cannot be used inside an effect cleanup function\nhttps:/*                                */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                */
	}
}

/**
 *
 *
 */
export function effect_in_unowned_derived() {
	if (DEV) {
		const error = new Error(`effect_in_unowned_derived\nEffect cannot be created inside a \`$derived\` value that was not itself created inside an effect\nhttps:/*                                       */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                       */
	}
}

/**
 *
 *
 *
 */
export function effect_orphan(rune) {
	if (DEV) {
		const error = new Error(`effect_orphan\n\`${rune}\` can only be used inside an effect (e.g. during component initialisation)\nhttps:/*                           */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                           */
	}
}

/**
 *
 *
 */
export function effect_pending_outside_reaction() {
	if (DEV) {
		const error = new Error(`effect_pending_outside_reaction\n\`$effect.pending()\` can only be called inside an effect or derived\nhttps:/*                                             */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                             */
	}
}

/**
 *
 *
 */
export function effect_update_depth_exceeded() {
	if (DEV) {
		const error = new Error(`effect_update_depth_exceeded\nMaximum update depth exceeded. This typically indicates that an effect reads and writes the same piece of state\nhttps:/*                                          */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                          */
	}
}

/**
 *
 *
 */
export function flush_sync_in_effect() {
	if (DEV) {
		const error = new Error(`flush_sync_in_effect\nCannot use \`flushSync\` inside an effect\nhttps:/*                                  */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                  */
	}
}

/**
 *
 *
 */
export function fork_discarded() {
	if (DEV) {
		const error = new Error(`fork_discarded\nCannot commit a fork that was already discarded\nhttps:/*                            */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                            */
	}
}

/**
 *
 *
 */
export function fork_timing() {
	if (DEV) {
		const error = new Error(`fork_timing\nCannot create a fork inside an effect or when state changes are pending\nhttps:/*                         */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                         */
	}
}

/**
 *
 *
 */
export function get_abort_signal_outside_reaction() {
	if (DEV) {
		const error = new Error(`get_abort_signal_outside_reaction\n\`getAbortSignal()\` can only be called inside an effect or derived\nhttps:/*                                               */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                               */
	}
}

/**
 *
 *
 *
 */
export function hydratable_missing_but_required(key) {
	if (DEV) {
		const error = new Error(`hydratable_missing_but_required\nExpected to find a hydratable with key \`${key}\` during hydration, but did not.\nhttps:/*                                             */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                             */
	}
}

/**
 *
 *
 */
export function hydration_failed() {
	if (DEV) {
		const error = new Error(`hydration_failed\nFailed to hydrate the application\nhttps:/*                              */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                              */
	}
}

/**
 *
 *
 */
export function invalid_snippet() {
	if (DEV) {
		const error = new Error(`invalid_snippet\nCould not \`{@render}\` snippet due to the expression being \`null\` or \`undefined\`. Consider using optional chaining \`{@render snippet?.()}\`\nhttps:/*                             */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                             */
	}
}

/**
 *
 *
 *
 */
export function lifecycle_legacy_only(name) {
	if (DEV) {
		const error = new Error(`lifecycle_legacy_only\n\`${name}(...)\` cannot be used in runes mode\nhttps:/*                                   */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                   */
	}
}

/**
 *
 *
 *
 */
export function props_invalid_value(key) {
	if (DEV) {
		const error = new Error(`props_invalid_value\nCannot do \`bind:${key}={undefined}\` when \`${key}\` has a fallback value\nhttps:/*                                 */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 *
 */
export function props_rest_readonly(property) {
	if (DEV) {
		const error = new Error(`props_rest_readonly\nRest element properties of \`$props()\` such as \`${property}\` are readonly\nhttps:/*                                 */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 *
 */
export function rune_outside_svelte(rune) {
	if (DEV) {
		const error = new Error(`rune_outside_svelte\nThe \`${rune}\` rune is only available inside \`.svelte\` and \`.svelte.js/ts\` files\nhttps:/*                                 */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                 */
	}
}

/**
 *
 *
 */
export function set_context_after_init() {
	if (DEV) {
		const error = new Error(`set_context_after_init\n\`setContext\` must be called when a component first initializes, not in a subsequent effect or after an \`await\` expression\nhttps:/*                                    */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                    */
	}
}

/**
 *
 *
 */
export function state_descriptors_fixed() {
	if (DEV) {
		const error = new Error(`state_descriptors_fixed\nProperty descriptors defined on \`$state\` objects must contain \`value\` and always be \`enumerable\`, \`configurable\` and \`writable\`.\nhttps:/*                                     */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                     */
	}
}

/**
 *
 *
 */
export function state_prototype_fixed() {
	if (DEV) {
		const error = new Error(`state_prototype_fixed\nCannot set prototype of \`$state\` object\nhttps:/*                                   */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                   */
	}
}

/**
 *
 *
 */
export function state_unsafe_mutation() {
	if (DEV) {
		const error = new Error(`state_unsafe_mutation\nUpdating state inside \`$derived(...)\`, \`$inspect(...)\` or a template expression is forbidden. If the value should not be reactive, declare it without \`$state\`\nhttps:/*                                   */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                   */
	}
}

/**
 *
 *
 */
export function svelte_boundary_reset_onerror() {
	if (DEV) {
		const error = new Error(`svelte_boundary_reset_onerror\nA \`<svelte:boundary>\` \`reset\` function cannot be called while an error is still being handled\nhttps:/*                                           */

		error.name = 'Svelte error';

		throw error;
	} else {
		throw new Error(`https:/*                                           */
	}
}